import { Action } from "@ngrx/store";
import { ITable } from "../../common/models/table";
import { IContext } from "../../context/models/context";
import { DashboardItem } from "../../dashboards/models/dashboard-item";

export const LOAD = '[Tenancy Schedule Table] Load';

export const LOAD_COMPLETE = '[Tenancy Schedule Table] Load Complete';
export const LOAD_ERROR = '[Tenancy Schedule Table] Load Error';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public context: IContext, public widget: DashboardItem) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: ITable, public widget: DashboardItem) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any, public widget: DashboardItem) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError;
